import {
  ADOBE_BROWSING_PLATFORM_KEY,
  ADOBE_COUNTRY_CODE_KEY,
  ADOBE_CUSTOMER_ID_KEY,
  ADOBE_LOGIN_STATUS_KEY,
  ADOBE_PAGE_LOAD_TIME_DOM_READY_KEY,
  ADOBE_PAGE_LOAD_TIME_FIRST_BYTE_KEY,
  ADOBE_PAGE_NAME_KEY,
  ADOBE_PAGE_TYPE_PROP_KEY,
  ADOBE_PAGE_TYPE_EVAR_KEY,
  ADOBE_PAGE_URL_KEY,
  ADOBE_SERVER_KEY,
  ADOBE_SITE_CONTENT_1_KEY,
  ADOBE_SITE_CONTENT_2_KEY,
  ADOBE_SITE_ID_KEY,
  ADOBE_VISITOR_TYPE_KEY,
  ADOBE_MERCHANDISING_ATTRIBUTION_CATEGORY_KEY,
  ADOBE_SALES_ATTRIBUTION_CATEGORY_KEY,
  ADOBE_TIMESTAMP_KEY
} from "./constants";
import getTimestamp from "./getTimestamp";

export default ({
  globals: {
    browsingPlatform,
    countryCode,
    customerId,
    loginStatus,
    pageLoadTimeDomReady,
    pageLoadTimeFirstByte,
    pageName,
    pageType,
    pageUrl,
    server,
    siteContent1,
    siteContent2,
    siteId,
    visitorType,
    attributionCategory
  }
}) => ({
  [ADOBE_BROWSING_PLATFORM_KEY]: browsingPlatform,
  [ADOBE_COUNTRY_CODE_KEY]: countryCode,
  [ADOBE_CUSTOMER_ID_KEY]: customerId,
  [ADOBE_LOGIN_STATUS_KEY]: loginStatus,
  [ADOBE_PAGE_LOAD_TIME_DOM_READY_KEY]: pageLoadTimeDomReady,
  [ADOBE_PAGE_LOAD_TIME_FIRST_BYTE_KEY]: pageLoadTimeFirstByte,
  [ADOBE_PAGE_NAME_KEY]: pageName,
  [ADOBE_PAGE_TYPE_PROP_KEY]: pageType,
  [ADOBE_PAGE_TYPE_EVAR_KEY]: pageType,
  [ADOBE_PAGE_URL_KEY]: pageUrl,
  [ADOBE_SERVER_KEY]: server,
  [ADOBE_SITE_CONTENT_1_KEY]: siteContent1,
  [ADOBE_SITE_CONTENT_2_KEY]: siteContent2,
  [ADOBE_SITE_ID_KEY]: siteId,
  [ADOBE_VISITOR_TYPE_KEY]: visitorType,
  [ADOBE_MERCHANDISING_ATTRIBUTION_CATEGORY_KEY]: attributionCategory,
  [ADOBE_SALES_ATTRIBUTION_CATEGORY_KEY]: attributionCategory,
  [ADOBE_TIMESTAMP_KEY]: getTimestamp()
});
